import classNames from 'classnames/bind';
import React, { forwardRef, ReactElement, useMemo } from 'react';
import { SortableWidgetProps, Widget } from '@creditsights/styleguide-web';
import { PageComponent } from '../../../models';
import DateFooter from '../common/DateFooter';
import { formatComponentBody } from './PageComponentWidget.logic';
import styles from './PageComponentWidget.module.scss';

const cx = classNames.bind(styles);

interface PageComponentWidgetProps extends SortableWidgetProps {
  component?: PageComponent;
}

const PageComponentWidget = (
  { component, ...sortableWidgetProps }: PageComponentWidgetProps,
  ref
): ReactElement | null => {
  const componentBody = useMemo(() => (component ? formatComponentBody(component) : ''), [component]);

  if (!component || !componentBody) {
    return null;
  }

  const dataTestId = component?.title.toLowerCase().split(' ').join('-') ?? 'page-component-widget';

  return (
    <Widget
      headerTitle={component.title ?? ''}
      footer={<DateFooter date={component.modifiedDate} dataTestId={`${dataTestId}-footer`} />}
      dataTestId={dataTestId}
      ref={ref}
      {...sortableWidgetProps}
    >
      <div
        data-testid={`${dataTestId}-body`}
        className={cx('body')}
        dangerouslySetInnerHTML={{ __html: componentBody }}
      />
    </Widget>
  );
};

export default forwardRef(PageComponentWidget);
